'use client';
import Tag from '@/components/atoms/tag';
import { Box, Button, Container, Typography } from '@mui/material';
import React from 'react';
import likeIcon from '/public/assets/svg/like.svg';
import Title from '@/components/atoms/title';
import ProgramCard from './programCard';
import { useGetProgramsQuery } from '@/redux/api/programApi';
import Link from 'next/link';
import { UniversityAdmission } from '@/types/program';
import ProgramCardSkeleton from '@/components/organisms/programCardSkelton';
import { COLORS } from '@/constants/colors';

interface ProgramsResponse {
  docs: UniversityAdmission[];
  pagination?: {
    totalDocs: number;
    limit: number;
    page: number;
    totalPages: number;
  };
}

const ProgramSection = ({
  favoritePage,
  isScholarShip,
  initialPrograms
}: {
  favoritePage?: boolean;
  isScholarShip?: boolean;
  initialPrograms?: ProgramsResponse | null;
}) => {
  // Only use client-side query if no initial programs are provided
  const { data: clientPrograms, isLoading: isClientLoading } =
    useGetProgramsQuery(
      { limit: 5 }
      // {
      //   skip: !!initialPrograms // Skip if we have initial data
      // }
    );

  // Use initial programs if available, otherwise use client-side data
  const programs = initialPrograms || clientPrograms;
  const isLoading = !initialPrograms && isClientLoading;

  return (
    <Box sx={{ ...(favoritePage && { backgroundColor: COLORS.bgColor }) }}>
      {isLoading ? (
        <Container sx={{ py: 7 }}>
          <ProgramCardSkeleton />
          <ProgramCardSkeleton />
          <ProgramCardSkeleton />
        </Container>
      ) : (
        <Container sx={styles.container}>
          {!favoritePage && (
            <>
              <Tag bgWhite icon={likeIcon} title="We Offer" />
              <Title title={'Programs'} />
            </>
          )}

          <Box gap="12px" mt={favoritePage ? 0 : 7.5}>
            {programs?.docs.map((program: UniversityAdmission) => (
              <Box mt={3} key={program._id}>
                <ProgramCard isFavorite={favoritePage} program={program} />
              </Box>
            ))}
          </Box>
          {!favoritePage && (
            <Link
              style={{
                textDecoration: 'none',
                color: 'white'
              }}
              href={isScholarShip ? '/search-scholarship' : '/programs'}
            >
              {programs?.docs.length === 0 ? (
                <Box mt={3}>
                  <Typography color="black" variant="h6">
                    No Program Found
                  </Typography>
                </Box>
              ) : (
                <Button variant="outlined" sx={styles.loadMoreBtn}>
                  Show More
                </Button>
              )}
            </Link>
          )}
        </Container>
      )}
    </Box>
  );
};

export default ProgramSection;

const styles = {
  container: {
    py: 7,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  },
  loadMoreBtn: { mt: 3, px: 10 }
};
